/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionSubmittedDateQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomVersionSubmittedDateQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionSubmittedDateQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionSubmittedDateQueryOperator>): AppSecopsSbomVersionSubmittedDateQueryOperator {
        let obj = Object.assign(new AppSecopsSbomVersionSubmittedDateQueryOperator(), model);
        AppSecopsSbomVersionSubmittedDateQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionSubmittedDateQueryOperator>): AppSecopsSbomVersionSubmittedDateQueryOperator {
        if (!model) return null;
        return AppSecopsSbomVersionSubmittedDateQueryOperator.newInstance(<AppSecopsSbomVersionSubmittedDateQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionSubmittedDateQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomVersionSubmittedDateQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionSubmittedDateQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionSubmittedDateQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.sbom_submitted_date === "string") {
            this.sbom_submitted_date = new Date(<string><any>this.sbom_submitted_date);
        }
    }

    /**
     * SBOM submitted date associated with the vulnerability
     */
    sbom_submitted_date: Date;

}
